(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[599],{

/***/ 32014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/index.js + 1 modules
var open_bank_account = __webpack_require__(53001);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/bahamas/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"Bahamas","imgAlt":"open bank account for Bahamas company","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Bahamas","uri":"/company-formation/bahamas"},{"title":"Open bank account","uri":"/company-formation/bahamas/open-bank-account"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/bahamas"},{"title":"Open Bank Account","uri":"/company-formation/bahamas/open-bank-account"},{"title":"Other Services","uri":"/company-formation/bahamas/other-services"}],"dataHowToOpen":{"title":"How to open a business account for<br/>Bahamas Companies","content":["<p>Regardless of what type of business you are operating, it is a golden rule that you should separate your personal and corporate finances. Then, setting up a business bank account is always in need. For Bahamas companies, you may have many banking options to set up a business account:</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Application with local banks in Bahamas</h3>","<p>Bahamas has been well-known for its privacy and security of the banking system. Recently the country has implemented changes to its long-standing history of international financial services to meet EU and OECD demands. As a result, Bahamas is a member of Tax Information Exchange Agreement (TIEA) with nearly 40 countries.</p>","<p>Financial services, specifically international banking are the second-most important factor to the Bahamas economy, which contributing up to approximately 17% of total GDP. Bahamas has promulgated International Business Companies Act in 1990, and subsequent initiatives to enhance the country’s status as a leading offshore financial center.</p>","<p>The Bahamas has a sound and well-regulated banking system comprised of domestic and large international banks from across the globe, which provides easy access to global capital markets. The central bank of Bahamas, established in 1974, pursues its legal mandate of maintaining the country financial stability.</p>","<p>Be advised that some brick-and-mortar banks don\'t accept opening a business account online.</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Going for offshore bank accounts or fintech solutions</h3>","<p>We currently don’t support opening bank accounts in Bahamas. However, a Bahamas IBC can open its account in most offshore banks including Singapore.</p>"]},"dataRequiredDocument":{"note":"<em>Additional supportive documents beyond the listed above might be requested to open your Bahamas company bank account depending on each local regulation, your business fields and on a case-by-case basis. Please contact us to know the exact documents needed for your case.</em>","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"","listContent":[{"text":"Application forms","content":[]},{"text":"Bank statements","content":[]},{"text":"Bank reference letter","content":[]},{"text":"Certified copies of passports, proofs of residence of all directors/shareholders","content":[]},{"text":"Business plan","content":[]},{"text":"Company business evidence (sales/purchase orders, invoice, etc.)","content":[]},{"text":"Certified copies of Anguilla company incorporation documents","content":[]},{"text":"Government certification of company good standing status.","content":[]}]}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/bahamas/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* bahamas */.R2,
        emi: bank_emis/* bahamas */.R2
      }
    })
  });
}

/***/ }),

/***/ 8937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/bahamas/open-bank-account",
      function () {
        return __webpack_require__(32014);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5881,5999,6618,2888,179], function() { return __webpack_exec__(8937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);